import $api from "@/frontend/shared/api/axios";

export async function removeCompetitorsFromPortfolioCompany({
  competitorsIds,
  portfolioCompanyId
}: {
  competitorsIds: number[];
  portfolioCompanyId: number;
}) {
  return $api.post(`/portfolio-companies/${portfolioCompanyId}/competitors/remove/bulk`, { competitorsIds });
}
